import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faSearch, faTrash, faXmark, faChevronRight, faChalkboardUser } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useGetCoTeachersByAssignmentMutation } from '../../../features/authentication/assignApiSlice';
import { useState } from 'react';
import { useAssignmentContext } from '../context';
import { useDeleteCollaboratorMutation } from '../../../features/authentication/authApiSlice';
import ConfirmationModal from '../../../components/ConfirmationPopUp';
import CustomToast from '../../../components/Toast';
import '../../../../src/pages/assignments/assignments.scss';

const AddCollaborators = ({
  isOpen,
  title,
  addBoxTitle,
  helpTooltip,
  onClose,
  placeHolder,
  searchValue, //search text
  setSearchValue,
  searchData, //search api
  teacherList, //selected teacher id
  setTeacherList,
  selectedMembers, //complete selected co-teacher data
  setSelectedMembers,
  teacherDataUpdate, //teacher data to update
  setTeacherDataUpdate,
  removeAll,
  isEnabled,
  setIsEnabled,
  updateCoTeacher, //update api
  isLoading,
  setUpdatedCoTeachersList,
  fromMoreActions
}) => {
  const coTeacherSelected = [];
  const [coteachers, setCoTeachers] = useState([]);
  const [getCoteachers] = useGetCoTeachersByAssignmentMutation();
  const [deleteAssignmentCollaborator] = useDeleteCollaboratorMutation();
  const { assignmentId, assignedData, setCollaboratorUpdate } = useAssignmentContext();
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [deleteCollaboratorId, setDeleteCollaboratorId] = useState('');
  const [deleteCollaboratorAssignmentId, setDeleteCollaboratorAssignmentId] = useState('');
  const [openedAssignments, setOpenedAssignments] = useState([]);
  const [coteacherIds, setCoteacherIds] = useState([]);

  const searchHandler = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length >= 3 && e.target.value != searchValue) {
      searchData(e.target.value);
      return;
    }
    setSelectedMembers([]);
  };
  useEffect(() => {
    getCoTeachersAsync();
  }, []);
  const getCoTeachersAsync = async () => {
    try {
      let paramIds = [];
      if (!fromMoreActions) {
        paramIds = assignedData.map((assignment) => {
          return assignment.assignmentId;
        });
      }
      else {
        paramIds = [assignmentId];
      }
      const options = {
        assignmentIds: paramIds
      };
      const allCoTeachers = await getCoteachers(options).unwrap();
      setCoTeachers(allCoTeachers);
      getAllCoteacherIds(allCoTeachers);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSelectMembersCheckboxChange = (member, event) => {
    let selectedMembersArray = selectedMembers.map((item) =>
      item.studentId === member.studentId ? { ...item, isSelected: event.target.checked } : item
    );
    setSelectedMembers(selectedMembersArray);

    const hasSelectedMember = selectedMembersArray.some((item) => item.isSelected);
    setIsEnabled(hasSelectedMember);
    if (teacherList.includes(member.studentId)) {
      setTeacherList(teacherList.filter((item) => item !== member.studentId));
    } else {
      coTeacherSelected.push(...teacherList, member.studentId);
      setTeacherList(coTeacherSelected);
    }
  };

  const addTeachers = () => {
    let selectedCoTeachers = [...teacherDataUpdate];

    selectedMembers.forEach((item) => {
      if (item.isSelected) {
        const existingCoTeacher = selectedCoTeachers.find(
          (coTeacher) => coTeacher.studentId === item.studentId
        );
        if (!existingCoTeacher) {
          selectedCoTeachers.push({
            studentId: item.studentId,
            fName: item.fName,
            lName: item.lName,
            login: item.login,
            schoolName: item.schoolName,
            allowEdit: false
          });
        }
      }
    });

    setTeacherDataUpdate(selectedCoTeachers);
  };

  const deleteSelectedHandler = (coTeacherId) => {
    const dataAvailable = teacherDataUpdate.filter((item) => item.studentId !== coTeacherId);
    setTeacherDataUpdate(dataAvailable);
    dataAvailable.length > 0 ? setIsEnabled(true) : setIsEnabled(false);
    const membersSelected = selectedMembers.map((item) =>
      item.studentId === coTeacherId && item.isSelected ? { ...item, isSelected: false } : item
    );
    setSelectedMembers(membersSelected);
    setTeacherList(teacherList.filter((item) => item !== coTeacherId));
  };

  const deleteCollaboratorHandler = (collaborator) => {
    setDeleteCollaboratorId(collaborator.id);
    setShowErrorMsg(true);
  };


  const deleteCollaborator = async () => {
    try {
      const deleteCollaboratorParam = {
        assignmentId: deleteCollaboratorAssignmentId,
        collaboratorId: deleteCollaboratorId
      };
      const deleteCollaboratorResponse = await deleteAssignmentCollaborator(
        deleteCollaboratorParam
      ).unwrap();
      if (deleteCollaboratorResponse) {
        const updatedArray = coteachers?.map((item1) => {
          if (item1.assignmentId === deleteCollaboratorAssignmentId) {
            const updatedCoTeachers = item1.coTeachers.filter((ct) => ct.id !== deleteCollaboratorId);
            return { ...item1, coTeachers: updatedCoTeachers };
          }
          return item1;
        });
        const deletedAssignmentData = updatedArray.filter(item => item.assignmentId === deleteCollaboratorAssignmentId);
        const updatedCollaborator = {
          collaboratorAssignmentId: deleteCollaboratorAssignmentId,
          collaboratorCount: deletedAssignmentData[0].coTeachers.length
        };
        setCollaboratorUpdate(updatedCollaborator);
        setCoTeachers(updatedArray);
        if (fromMoreActions)
          setUpdatedCoTeachersList(updatedArray[0].coTeachers);
        CustomToast('Collaborator has been deleted', 'success');
        const updatedCoteacherIds = coteacherIds.filter(coteacherId => coteacherId != deleteCollaboratorId);
        setCoteacherIds(updatedCoteacherIds);
        setShowErrorMsg(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const assignmentCollapseHandler = (collapseAssignmentId) => {
    if (!openedAssignments.includes(collapseAssignmentId)) {
      const newOpenedAssignments = [collapseAssignmentId];
      newOpenedAssignments.push(...openedAssignments);
      setOpenedAssignments(newOpenedAssignments);
    }
    else {
      const updatedOpenAssignments = openedAssignments.filter(item => item !== collapseAssignmentId);
      setOpenedAssignments(updatedOpenAssignments);
    }
  };

  const getAllCoteacherIds = (selectedAssignments) => {
    let coteacherIds = [];
    selectedAssignments.map((item) => {
      const ids = item.coTeachers.map(coteacher => coteacher.id);
      coteacherIds = [...coteacherIds, ...ids];
    });
    const uniqueIds = [...new Set(coteacherIds)];
    setCoteacherIds(uniqueIds);
  };

  return (
    <>
      <Modal contentWidth="100%" isOpen={isOpen} hideHeader={true}>
        <div className="row">
          <div className="co-teacher-header">
            <div className="co-teacher-header-in d-flex gap-2 w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                <h3 className="primary-title mb-0">{title}</h3>
                {helpTooltip && (
                  <OverlayTrigger
                    key="tooltip-add"
                    placement="top"
                    overlay={
                      <Tooltip id="add-tooltip" className="co-teacher-tooltip">
                        <p className="mb-0">
                          A collaborator will be able to work on your assignment with you - adding,
                          removing, and editing content as if it were their own assignment
                        </p>
                      </Tooltip>
                    }>
                    <FontAwesomeIcon icon={faInfo} className="icon-info-circle" />
                  </OverlayTrigger>
                )}
              </div>
              <div onClick={() => onClose(false)}>
                <FontAwesomeIcon className="ms-2 modal-close-icon" size="2x" icon={faXmark} />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="co-teacher-box">
              <p>
                Enter either a login id or user&#39;s name (Last, First), then select from dropdown
                and press add.
              </p>
              <div className="custom-search position-relative mb-3">
                <FontAwesomeIcon icon={faSearch} />
                <input
                  type="text"
                  value={searchValue}
                  onChange={(e) => searchHandler(e)}
                  placeholder={placeHolder}
                  className="form-control"
                />
              </div>

              <div className="co-teacher-listing-modal overflow-auto mb-3">
                {selectedMembers
                  .map((member, index) => (
                    <>
                      {coteacherIds.includes(member.studentId) ?
                        (
                          <OverlayTrigger
                            key={`tooltip-coteacher-disabled${index}`}
                            placement="right"
                            overlay={
                              <Tooltip id="add-tooltip" className="custom-tooltip">
                                <p className="mb-0">
                                This teacher cannot be added as a collaborator because as a co-teacher of your class, they already have edit assignment rights
                                </p>
                              </Tooltip>
                            }>
                            <div
                              disabled={true}
                              key={index}
                              className="form-check-data d-flex justify-content-between bg-light align-items-center mb-3">
                              <label className="form-check-label ms-3 text-grey" htmlFor="Optionsc">
                                {member.lName + ' ' + member.fName + ' (' + member.login + ')'}
                              </label>
                              <input
                                disabled={true}
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="option-change"
                                checked={false}
                              />
                            </div>
                          </OverlayTrigger>
                          
                        ) : (
                          <div
                            key={index}
                            className="form-check-data d-flex justify-content-between align-items-center mb-3">
                            <label className="form-check-label ms-3" htmlFor="Optionsc">
                              {member.lName + ' ' + member.fName + ' (' + member.login + ')'}
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="option-change"
                              onChange={(e) => handleSelectMembersCheckboxChange(member, e)}
                              checked={teacherList.includes(member.studentId, member.classId)}
                            />
                          </div>
                        )
                      }
                    </>
                  ))}
              </div>

              <div className="col-12 d-flex justify-content-end gap-2 add-remove-wrapper">
                <button className="btn btn-castleGray" onClick={removeAll}>
                  Remove All
                </button>
                <button className="btn btn-castleWhite" disabled={!isEnabled} onClick={addTeachers}>
                  Add
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="co-teacher-box-2 h-100 d-flex flex-column">
              <div className='d-flex gap-2'>
                <h4 className="secondary-title">{addBoxTitle}</h4>
              </div>
              <div>
                {teacherDataUpdate.length > 0 && (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Newly Added</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {teacherDataUpdate.map((member) => (
                        <tr key={member.id}>
                          <td>
                            {member.lName} {member.fName} ({member.login})
                          </td>
                          <td>
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="co-teacher-delete"
                              onClick={() => deleteSelectedHandler(member.studentId)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              {coteachers.length > 0 && (
                <>
                  {coteachers.map((item, index) => (
                    <table key={'table' + index} className="table classroom-content">
                      <thead className={`classroom-content-box ${openedAssignments.includes(item.assignmentId) && 'open'} `} key={'tr' + index}>
                        <tr className="classroom-content-header justify-content-between align-items-center">
                          {item.assignmentName.length > 50 ?
                            (<OverlayTrigger
                              key="assignment-name-tooltip"
                              placement="top"
                              overlay={<Tooltip className="custom-tooltip">{item.assignmentName}</Tooltip>}>
                              <th className='text-truncate w-min-max-250'>Assignment Name : {item.assignmentName}</th>
                            </OverlayTrigger>)
                            :
                            (<th>Assignment Name : {item.assignmentName}</th>)
                          }
                          <th><button onClick={() => assignmentCollapseHandler(item.assignmentId)} className="rounded-circle">
                            <FontAwesomeIcon icon={faChevronRight} />
                          </button>
                          </th>
                        </tr>
                      </thead>
                      {openedAssignments.includes(item.assignmentId) && (
                        <tbody>
                          {item.coTeachers.length > 0 ?
                            item.coTeachers.map((member, index) => (
                              <tr key={'coteacher' + index}>
                                <td>
                                  {member.name}
                                  {!member.isDeletable &&
                                  <span className='badge badge-info mx-2 p-2'>
                                    <FontAwesomeIcon icon={faChalkboardUser}/>
                                  </span>
                                  }
                                </td>
                                {member.isDeletable && (
                                  <td>
                                    <FontAwesomeIcon
                                      icon={faTrash}
                                      className="co-teacher-delete"
                                      onClick={() => { deleteCollaboratorHandler(member); setDeleteCollaboratorAssignmentId(item.assignmentId); }}
                                    />
                                  </td>
                                )}
                                {!member.isDeletable && (
                                  <td>
                                    <OverlayTrigger
                                      key="delete-coteacher"
                                      placement="left"
                                      overlay={<Tooltip className="custom-tooltip">Collaborator access cannot be removed from a co-teacher.</Tooltip>}>
                                      <FontAwesomeIcon
                                        disabled={true}
                                        icon={faTrash}
                                        className="co-teacher-delete-disabled"
                                      />
                                    </OverlayTrigger>
                                  </td>
                                )}
                              </tr>
                            ))
                            :
                            <tr>
                              <td colSpan={2} align='center'>No Collaborators Found</td>
                            </tr>
                          }
                        </tbody>
                      )}
                    </table>
                  ))}
                </>
              )}
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end mt-3">
            <button className="btn btn-castleGray me-2" onClick={() => onClose(false)}>
              Cancel
            </button>
            <button className="btn btn-castleRed" disabled={isLoading} onClick={updateCoTeacher}>
              Update
            </button>
          </div>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={showErrorMsg}
        onClose={() => setShowErrorMsg(false)}
        onSave={() => deleteCollaborator(deleteCollaboratorId)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={'Are you sure you want to permanently delete the record?'}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </>
  );
};

AddCollaborators.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  addBoxTitle: PropTypes.string,
  helpTooltip: PropTypes.bool,
  onClose: PropTypes.func,
  placeHolder: PropTypes.string,
  searchData: PropTypes.func,
  removeAll: PropTypes.func,
  updateCoTeacher: PropTypes.func,
  isLoading: PropTypes.bool,
  teacherList: PropTypes.array,
  setTeacherList: PropTypes.func,
  teacherDataUpdate: PropTypes.array,
  setTeacherDataUpdate: PropTypes.func,
  selectedMembers: PropTypes.array,
  setSelectedMembers: PropTypes.func,
  isEnabled: PropTypes.bool,
  setIsEnabled: PropTypes.func,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
  setUpdatedCoTeachersList: PropTypes.func,
  fromMoreActions: PropTypes.bool
};

export default AddCollaborators;
